(function () {

    function getABMUserInterests() {
        const piraObj = window.getPiraObj?.();
        const bpid = piraObj?.bpid;
        const duns = piraObj?.duns;
        const email = piraObj?.em;
        const emailDomain = email?.includes('@') ? email.split('@')[1] : null;
        const ipDomain = piraObj?.domain;

        let url = '/bin/rockwell-automation/abm-personalization';
        const isLocalhost = window.location.hostname === 'localhost';
        if (isLocalhost && window.ABM_DEV_URL) {
            url = `${window.ABM_DEV_URL}${url}`;
        }

        if (bpid) {
            if (url.includes('?')) {
                url += `&bpid=${bpid}`;
            } else {
                url += `?bpid=${bpid}`;
            }
        }

        if (emailDomain) {
            if (url.includes('?')) {
                url += `&emailDomain=${emailDomain}`;
            } else {
                url += `?emailDomain=${emailDomain}`;
            }
        }

        if (duns) {
            if (url.includes('?')) {
                url += `&duns=${duns}`;
            } else {
                url += `?duns=${duns}`;
            }
        }

        if (ipDomain) {
            if (url.includes('?')) {
                url += `&ipDomain=${ipDomain}`;
            } else {
                url += `?ipDomain=${ipDomain}`;
            }
        }

        if (!url.includes('?')) {
            console.info('ABM User Context: No valid query parameters');
            return Promise.resolve({ error: 'No valid query parameters' });
        }

        return fetch(url)
            .then((res) => {
                if (!res.ok) throw new Error(`Fetch failed: ${res.status} ${res.statusText}`);
                return res.json();
            })
            .then((data) => ({
                ...data,
                bpid,
                emailDomain,
                ipDomain,
            }));
    }

    document.addEventListener('piraLoadedSynced', () => {

        const piraObj = window.getPiraObj?.();
        if (!piraObj) {
            console.warn('ABM User Context: Pira object not available, skipping');
            return;
        }

        const abmUserInterests = localStorage.getItem('abmUserInterests');
        if (!abmUserInterests || !validateAbmData(abmUserInterests)) {
            const fallbackInterests = {
                industry: [],
                buy_intent: [],
                research_intent: [],
                topic: [],
                duns: null,
                lookupMethod: null,
                userIntent: 'no-intent',
            };
            console.log('ABM User Context: Fetching new interests from API');
            getABMUserInterests()
                .then((interests) => {
                    const finalInterests = interests && !interests.error && Object.keys(interests).length > 0 ? interests : fallbackInterests;
                    // set cache for finalInterests to 1 week
                    const cacheTime = Date.now() + (7 * 24 * 60 * 60 * 1000);
                    const intent = determineUserIntent(finalInterests);
                    const finalInterestsWithCache = {
                        ...finalInterests,
                        expiry: cacheTime,
                        userIntent: intent,
                    };
                    localStorage.setItem('abmUserInterests', JSON.stringify(finalInterestsWithCache));

                    window.dispatchEvent(new CustomEvent('abmUserInterestsReady', { detail: finalInterests }));
                    console.log('ABM User Interests Ready');
                })
                .catch((err) => {
                    console.warn('ABM Interests fetch failed:', err);
                    // Ensure fallback data follows the same caching rules   as successful responses
                    const cacheTime = Date.now() + (7 * 24 * 60 * 60 * 1000); // 1 week
                    const intent = determineUserIntent(fallbackInterests);
                    const fallbackInterestsWithCache = {
                        ...fallbackInterests,
                        expiry: cacheTime,
                        userIntent: intent,
                    };
                    localStorage.setItem('abmUserInterests', JSON.stringify(fallbackInterestsWithCache));

                    window.dispatchEvent(new CustomEvent('abmUserInterestsReady', { detail: fallbackInterestsWithCache }));
                    console.log('ABM User Interests Ready (fallback)');
                });
        } else {
            console.log('abmUserInterests is valid, dispatching event');
            window.dispatchEvent(new CustomEvent('abmUserInterestsReady', { detail: JSON.parse(abmUserInterests) }));
        }
    });

    function determineUserIntent(interests) {
        if (interests?.buy_intent?.length) return 'buy-intent';
        if (interests?.research_intent?.length || interests?.topic?.length) return 'research-intent';
        return 'no-intent';
    }

    function validateAbmData(abmUserInterestsString) {
        const piraObj = window.getPiraObj?.();
        const bpid = piraObj?.bpid;
        const duns = piraObj?.duns;
        const email = piraObj?.em;
        const emailDomain = email?.includes('@') ? email.split('@')[1] : null;

        if (!abmUserInterestsString) {
            console.warn('ABM Data is not valid - no cached data');
            return false;
        }

        let abmUserInterests;
        try {
            abmUserInterests = JSON.parse(abmUserInterestsString);
        } catch (e) {
            console.warn('ABM Data is not valid, JSON parse error:', e);
            return false;
        }

        // Check expiry first since it's most common failure
        if (abmUserInterests.expiry < Date.now()) {
            console.warn('ABM Data is not valid, cache expired:', new Date(abmUserInterests.expiry).toISOString());
            return false;
        }

        // Only validate fields that exist in both current and cached data
        if (bpid && bpid !== abmUserInterests.bpid) {
            console.warn('ABM Data is not valid, bpid mismatch:', bpid, '!==', abmUserInterests.bpid);
            return false;
        }
        if (duns && duns !== abmUserInterests.duns) {
            console.warn('ABM Data is not valid, duns mismatch:', duns, '!==', abmUserInterests.duns);
            return false;
        }
        if (emailDomain && emailDomain !== abmUserInterests.emailDomain) {
            console.warn('ABM Data is not valid, emailDomain mismatch:', emailDomain, '!==', abmUserInterests.emailDomain);
            return false;
        }

        console.log('ABM Data validation successful');
        return true;
    }

    function flushAbmData() {
        localStorage.removeItem('abmUserInterests');
        localStorage.removeItem('abmRecos');
        const locale = document.documentElement.lang.toLowerCase() || 'en-us';
        sessionStorage.removeItem(`cdpRecos-${locale}`);
        if (localStorage.getItem('abmUserData')) {
            localStorage.removeItem('abmUserData');
        }
    }

    window.addEventListener('piraLoggingIn', () => {
        flushAbmData();
    });
    window.addEventListener('piraLoggingOut', () => {
        flushAbmData();
    });

    // LOCALHOST ONLY //
    if (window.location.hostname === 'localhost') {
        window.addEventListener('load', () => {
            window.ABM_DEV_URL = 'https://dev-aem.rockwellautomation.com';
            window.getPiraObj = () => ({
                bpid: '0001081414',
                duns: '999999999999996',
                em: 'radbx@ra.rockwell.com',
                domain: 'test.com',
                companyCountry: 'USA',
                companyName: 'Bowery Residents\' Committee, Inc.',
                country: 'US',
                date: '1752784056938',
                domesticUltimateName: 'Bowery Residents\' Committee, Inc.',
                experience: 'Experience B - gradient text',
                hasDoNotTrack: false,
                fn: 'Dbxx1 DemoUser',
                functionalCookies: true,
                id: 'Q0001648',
                industryAffinity: 'Food & Beverage',
                industryNaics: 'Other Individual and Family Services',
                ipCountry: 'US',
                ln: 'DONOT UPDATE INFO',
                myCompany: 'DBx Demo',
                myCountryCode: 'US',
                myCustomerType: 'End User',
                myIndustry: 'Airports',
                myLanguage: 'en',
                myPhone: '14143820282',
                myTitle: 'Engineering - Chemical',
                naicsCodes: '#624190#####',
                networthNum: '4883562',
                performanceCookies: true,
                piraVersion: '0.62i',
            });
            // timeout to ensure pira is loaded
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('piraLoadedSynced'));
            }, 2000);
        });
    }
}());
// LOCALHOST ONLY //
